<div class="formulaire">
  <ul role="list">
    <li role="listitem" *ngFor="let changement of historique">Passage <span *ngIf="changement.type == type.Avis">de l'avis</span><span *ngIf="changement.type == type.Flux">du flux</span> {{ changement.reference }} au statut {{ changement.statut }} le {{ changement.date | date:'d MMMM y à H\'h\'mm':'Europe/Paris' }} </li>
  </ul>
</div>
